import fetchServer from "../fetchServer";

export default async function cancelPackageBooking(id, cancellationReason) {
  var result = {
    return: 0,
    msg: "Error",
    data: [],
  };

  await fetchServer({
    method: "POST",
    url: `/product/v1/nobiPackage/booking/cancel/${id}`,
    // data: { cancellationReason },
  })
    .then((res) => {
      if (res) {
        if (res.status === 200) {
          result = { return: 1, msg: "Successfull", data: res.data.data };
        } else if (res?.data?.error) result["msg"] = res.data.error;
        else if (res?.data?.message) result["msg"] = res.data.message;
      }
    })
    .catch((err) => {
      console.log(err.message, err);
      if (err.message === "Network Error!") {
        result["msg"] = "Network Error!";
        result["error"] = "Please check your connection.";
      }
    });

  return result;
}
